import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, throwError } from 'rxjs';

import { AuthRoutes } from '@bn/auth';
import { AuthService } from '@bn/auth/services';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && authService.isLoggedIn()) {
        authService.logout();
        router.navigate(['/', AuthRoutes.Auth, AuthRoutes.Login]);
      }

      return throwError(() => error);
    }),
  );
};
